import React, {Component} from "react";
import applogic from "../applogic.js";

class Modal extends Component {
    onSubmitClick(e) {
        this.text = this.textarea.value;
        this.textarea.value = '';
        applogic.handleBugReportSubmit(this);
    }
    render() {
        return (
            <div className="modal-bug-report-wrapper">
                <button type="button" className="btn btn-primary modal-bug-report-btn" data-toggle="modal"
                        data-target="#modalBugReport">
                    Feedback
                </button>
                <div className="modal fade" id="modalBugReport" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Report bug!</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p>
                                    App is still buggy. We know!
                                </p>
                                <p>
                                    Partly becasue we are just starting up, partly becasue we don't have many student
                                    accounts to test,
                                    and partly the IVLE API to blame :)
                                </p>
                                <p>
                                    That's why we made bug report really easy. Help me, help you, please write the bug
                                    you encountered below.
                                </p>
                                <p>We will fix it! Let's make it better together &#x1F602;</p>
                                <textarea ref={textarea => this.textarea = textarea}></textarea>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button type="button" onClick={this.onSubmitClick.bind(this)}
                                        className="btn btn-primary" data-dismiss="modal">Send report
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Modal;


// WEBPACK FOOTER //
// ./src/componentsHeader/ModalBugReport.js